import { render, staticRenderFns } from "./UserRoleDetails.vue?vue&type=template&id=966b792c&scoped=true&"
import script from "./UserRoleDetails.vue?vue&type=script&lang=ts&"
export * from "./UserRoleDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966b792c",
  null
  
)

export default component.exports